document.querySelectorAll('.password-reveal-toggle').forEach((toggle) => {
  toggle.addEventListener('change', () => {
    const wrapper = toggle.closest('div');
    const input = wrapper.querySelector('input[type="password"], input[type="text"]');
    const label = wrapper.querySelector('span');
    if (input) {
      input.type = toggle.checked ? 'text' : 'password';
    }
    if (label) {
      label.textContent = toggle.checked ? 'Hide' : 'Show';
    }
    toggle.setAttribute('aria-label', (toggle.checked ? 'Hide' : 'Show') + ' ' + toggle.dataset.label);
  });
});
